import { UrlBuilder } from "../../domain/usecase/url-builder";

export class BuildUrl implements UrlBuilder {
  build (link: string, params: Record<string, string>): string {
    const query = new URLSearchParams(params)
    if (link.match(/\?/)) {
      return `${link}&${query}`
    }
    return `${link}?${query}`
  }
}